import BaseObject from '../../../base/base_object';
import Event from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';

export default class GamesJackpotsPublisher extends BaseObject {
    static CLASS = 'GamesJackpotsPublisher';

    init(params) {
        super.init(params);

        if(!params.serviceFactory) {
            this.throwArgumentExpected('12', 'init', 'serviceFactory');
        }

        if(!params.refreshInterval) {
            this.throwArgumentExpected('16', 'init', 'refreshInterval');
        }

        this._serviceFactory = params.serviceFactory;
        this._refreshInterval = params.refreshInterval;
    }

    _publishQueue = [];
    _observableSubscription = null;

    /**
     *
     * @param gamesJackpotsObject {
     *      gameType1: {
     *          AmountInCents: number,
     *      },
     *      gameType2: {
     *          AmountInCents: number
     *      }
     */
    delayPublish(gamesJackpotsObject) {
        let gamesJackpotsArray = this._createGamesJackpotsArray(gamesJackpotsObject);
        if(gamesJackpotsArray.length === 0) {
            return;
        }

        this._disposeObservableSubscription();

        gamesJackpotsArray.forEach(gameJackpot => {
            this._publishQueue.push(gameJackpot);
        });

        this._observableSubscription = this._serviceFactory.observableFactoryService().fromInterval(this._refreshInterval.totalMilliseconds / this._publishQueue.length, 'JACKPOT_FEEDS_PUBLISHER_INTERVAL')
            .forEach(() => {
                this._publishGame(this._publishQueue.shift());

                if(this._publishQueue.length === 0) {
                    this._disposeObservableSubscription();
                }
            });
    }

    /**
     *
     * @param gamesJackpotsObject {
     *      gameType1: {
     *          AmountInCents: number,
     *      },
     *      gameType2: {
     *          AmountInCents: number
     *      }
     */
    forcePublish(gamesJackpotsObject) {
        if(!gamesJackpotsObject) {
            return;
        }

        let gameTypes = Object.keys(gamesJackpotsObject);
        if(gameTypes.length === 0) {
            return
        }

        let eventData = {};

        gameTypes.forEach(gameType => {
            eventData[gameType] = gamesJackpotsObject[gameType].AmountInCents
        });

        Event.fire(SYSTEM_EVENTS.LIVE_FEEDS_JACKPOT_AMOUNTS_BY_GAME_UPDATED, eventData);

    }

    _createGamesJackpotsArray(gamesJackpots) {
        if(!gamesJackpots) {
            return [];
        }

        return Object.keys(gamesJackpots).map(gt => {
            return {
                gameType: gt,
                amountInCents: gamesJackpots[gt].AmountInCents
            };
        });


    }

    _publishGame(gameJackpot) {
        Event.fire(SYSTEM_EVENTS.LIVE_FEEDS_JACKPOT_AMOUNTS_BY_GAME_UPDATED, {
            [gameJackpot.gameType]: gameJackpot.amountInCents
        });
    }

    _disposeObservableSubscription() {
        if(this._observableSubscription) {
            this._observableSubscription.dispose();
            this._observableSubscription = null;
        }
    }
}